import { render, staticRenderFns } from "./PWAPopUp.vue?vue&type=template&id=d1af27e2"
import script from "./PWAPopUp.vue?vue&type=script&lang=js"
export * from "./PWAPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports